const styles = (theme) => ({
    dialogContainer: {
        userSelect: "none",
        backgroundColor: theme.ModalBGColor,
        maxWidth: '670px',
        width: "45%",
        display: "flex",
    },
    dialogTitle: {
        fontSize: theme.headerTextFontSize,
        fontWeight: 600,
        textAlign: "left",
        display: "flex",
        paddingBottom: "inherit",
        flexDirection: "column",
        color: theme.HeaderSelectedText,
    },
    headerDescription: {
      color: theme.TextColor,
      fontWeight: 400,
      fontSize: theme.textFontSize,
      marginBottom: 24,
    },
    dialogWrapper: {},
    divider: {
        borderBottom: `1px solid ${theme.gridIconBorderColor}`,
        width:"100%",
        marginBottom: 11,
        opacity:"0.7"
    },
    dialogActionStyle: {
        display: "flex",
        justifyContent: "space-between",
        padding: "0 24 12 24",
        margin: 0
    },
    dialogButtonStyle: {
        fontSize: theme.headerTextFontSize,
        display: "flex",
        textTransform: "none",
        borderRadius: "2px",
        float: "right",
        marginLeft: 12
    },
    headerLabel: {
        color: theme.HeaderSelectedText,
        fontSize: theme.headerTextFontSize,
        fontWeight: 600,
    },
    headerStyle: {
        border: `1px solid ${theme.AppBGColor}`,
        padding: "12px",
        borderRadius: "4px 4px 0 0",
    },
    fullWidth: { width: "100%" },
    showPrevMsg: {
      margin: 0
    },
    showPrevMsgLabel: {
      fontSize: theme.textFontSize,
      color: theme.TextColor,
      opacity: 0.6,
      alignItems: "left"
    },
    expandStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
      padding: 2,
    },
    expandOpen: {
        transform: 'rotate(180deg)',
        padding: 2,
    },
    expandIcon: {
        color: theme.iconColor,
        height: 30,
        width: 30,
    },
    flexRow: {
        display: "flex",
        direction: "column",
        "&>div": {
            flex: 1,
            width: "100%",
        },
    },
    footer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    actionButton: {
      display: "flex",
      justifyContent: "flex-end",
      margin: 0,
    },
    radioContainer: {
      display: "flex",
      justifyContent: "space-between",
    }
});

export default styles;